import { render } from "./Content.vue?vue&type=template&id=326e3b18&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=326e3b18&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326e3b18"]])

export default __exports__